import { render, staticRenderFns } from "./SingleSelector.vue?vue&type=template&id=3bcb38c3&scoped=true&"
import script from "./SingleSelector.vue?vue&type=script&lang=js&"
export * from "./SingleSelector.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelector.vue?vue&type=style&index=0&id=3bcb38c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb38c3",
  null
  
)

export default component.exports